/**
 * @file variantDiseasevariantDiseaseClassificationCalcuate.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Oct 28, 2023 02:48 PM
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { stringExists } from 'src/@common/utilities';

import {
    VARIANT_CLASSIFICATION_CALCULATE_REQUEST,
    variantDiseaseClassificationCalculateSuccess,
    variantDiseaseClassificationCalculateFailure,
} from 'src/store/actions/variant/variantDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/variant/variantDiseaseClassification/calculate';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            variantDiseaseId: payload.variantDiseaseId,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* requestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (resp.payload.errorExists && stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(variantDiseaseClassificationCalculateSuccess(resp.payload));

    } catch (error) {
        yield put(variantDiseaseClassificationCalculateFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }


}

export default function* searchRequestMonitor() {
    yield takeLatest(VARIANT_CLASSIFICATION_CALCULATE_REQUEST, requestSaga);
}
